export const TARGET_WORD_LENGTH = 5;
export const NO_OF_GUESSES = 6;
